module.exports = __webpack_public_path__ + "img/icon-needs-search.e72895ed.svg";